import React from 'react';
import Icon from '../../../components/AppIcon';

const ResourceUtilizationChart = ({ resources }) => {
  const getUtilizationColor = (percentage) => {
    if (percentage >= 90) return 'bg-error';
    if (percentage >= 70) return 'bg-warning';
    return 'bg-success';
  };

  const getStatusIcon = (percentage) => {
    if (percentage >= 90) return 'AlertTriangle';
    if (percentage >= 70) return 'AlertCircle';
    return 'CheckCircle';
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Resource Utilization</h3>
        <Icon name="BarChart3" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4 md:space-y-5">
        {resources?.map((resource) => (
          <div key={resource?.id}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name={resource?.icon} size={18} className="text-muted-foreground" />
                <span className="text-sm md:text-base font-medium text-foreground">{resource?.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground">{resource?.utilized}/{resource?.total}</span>
                <Icon 
                  name={getStatusIcon(resource?.percentage)} 
                  size={16} 
                  className={resource?.percentage >= 90 ? 'text-error' : resource?.percentage >= 70 ? 'text-warning' : 'text-success'}
                />
              </div>
            </div>
            <div className="relative h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className={`absolute left-0 top-0 h-full ${getUtilizationColor(resource?.percentage)} transition-all duration-500`}
                style={{ width: `${resource?.percentage}%` }}
              />
            </div>
            <div className="flex items-center justify-between mt-1">
              <span className="text-xs text-muted-foreground">{resource?.percentage}% utilized</span>
              {resource?.conflicts > 0 && (
                <span className="text-xs text-error font-medium">{resource?.conflicts} conflicts</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourceUtilizationChart;